import en from './locale/en.json';
import es from './locale/es.json';

export default {
  en,
  es,
};
